<template>
  <main class="links-page">
    <section class="links-shell">
      <header class="profile">
        <img :src="brand.logo" alt="Maxica" class="profile-logo" />
        <h1>Bodega Maxica</h1>
        <p class="bio">{{ brand.headline }} Calidad y precio en uno.</p>
        <div class="socials" aria-label="Redes sociales">
          <a
            v-for="social in socialLinks"
            :key="social.title"
            :href="social.url"
            target="_blank"
            rel="noopener"
            :title="social.title"
          >
            <i :class="['mdi', social.icon]"></i>
          </a>
        </div>
      </header>

      <section class="main-actions" aria-label="Accesos principales">
        <a :href="brand.catalogUrl" class="link-row">
          <span class="row-thumb row-icon"><i class="mdi mdi-storefront-outline"></i></span>
          <span class="row-copy">
            <strong>Catálogo web</strong>
            <small>Ver productos y referencias disponibles</small>
          </span>
          <i class="mdi mdi-dots-vertical row-menu"></i>
        </a>
        <a :href="brand.mapsUrl" target="_blank" rel="noopener" class="link-row">
          <span class="row-thumb row-icon"><i class="mdi mdi-map-marker-radius-outline"></i></span>
          <span class="row-copy">
            <strong>Ubicación</strong>
            <small>{{ brand.address }}</small>
          </span>
          <i class="mdi mdi-dots-vertical row-menu"></i>
        </a>
      </section>

      <section class="group-list" aria-label="Grupos mayoristas">
        <a
          v-for="group in orderedGroups"
          :key="group.title"
          :href="group.url"
          target="_blank"
          rel="noopener"
          class="link-row"
        >
          <span class="row-thumb">
            <img :src="group.thumb || brand.logo" :alt="group.title" />
          </span>
          <span class="row-copy">
            <strong>{{ group.title }}</strong>
            <small>WhatsApp Community · Unirse gratis</small>
          </span>
          <i class="mdi mdi-dots-vertical row-menu"></i>
        </a>
      </section>
    </section>
  </main>
</template>

<script>
import { maxicaBrand, socialLinks, wholesaleGroups } from "@/data/maxicaLinks";

export default {
  name: "LinksMaxica",
  data() {
    return {
      brand: maxicaBrand,
      socialLinks,
      wholesaleGroups,
    };
  },
  computed: {
    orderedGroups() {
      return [...this.wholesaleGroups].sort((a, b) => (a.order || 0) - (b.order || 0));
    },
  },
};
</script>

<style scoped>
.links-page {
  min-height: 100vh;
  padding: 28px 14px 48px;
  background:
    linear-gradient(145deg, rgba(3, 3, 3, 0.98), rgba(18, 17, 19, 0.96) 48%, rgba(9, 9, 10, 0.98)),
    #0b0b0b;
  color: #fff;
}

.links-shell {
  width: min(100%, 560px);
  margin: 0 auto;
}

.profile {
  text-align: center;
  padding: 34px 8px 22px;
}

.profile-logo {
  width: 92px;
  height: 92px;
  object-fit: contain;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
}

.profile h1 {
  margin: 20px 0 0;
  font-size: clamp(1.7rem, 6vw, 2.2rem);
  line-height: 1.05;
  letter-spacing: 0;
}

.bio {
  max-width: 400px;
  margin: 7px auto 0;
  color: #f4f0ee;
  font-weight: 700;
  line-height: 1.45;
}

.socials {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 19px;
}

.socials a {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  color: #fff;
  text-decoration: none;
  font-size: 32px;
}

.main-actions,
.group-list {
  display: grid;
  gap: 10px;
}

.main-actions {
  margin: 10px 0 10px;
}

.link-row {
  position: relative;
  min-height: 66px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 46px;
  border-radius: 8px;
  color: #fff;
  text-decoration: none;
  background: #000;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.24);
}

.row-thumb {
  position: absolute;
  left: 10px;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  overflow: hidden;
  background: #111;
  flex: 0 0 auto;
}

.row-thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  padding: 4px;
}

.row-icon {
  display: grid;
  place-items: center;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 22px;
}

.row-menu {
  position: absolute;
  right: 13px;
  color: rgba(255, 255, 255, 0.56);
  font-size: 18px;
}

.row-copy {
  min-width: 0;
  text-align: center;
}

.row-copy strong,
.row-copy small {
  display: block;
}

.row-copy strong {
  font-size: 1.03rem;
  line-height: 1.15;
}

.row-copy small {
  margin-top: 3px;
  color: rgba(255, 255, 255, 0.66);
  font-size: 0.82rem;
  line-height: 1.25;
}

@media (max-width: 520px) {
  .links-page {
    padding-top: 16px;
  }

  .profile-logo {
    width: 82px;
    height: 82px;
  }

  .link-row {
    min-height: 62px;
    padding: 10px 36px 10px 54px;
  }
}
</style>
